import { ProductType } from '../../types';
import { PlannerEcsSystem } from './System';
import { ComponentIds } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
export class LightSelectionSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'LightSelectionSystem', ComponentIds.SELECTED_COMPONENT_ID);
        this.coreApi = coreApi;
    }
    onAdd(entity) {
        if (entity.hasComponent(ComponentIds.LIGHT_COMPONENT_ID)) {
            if (this.coreApi.entities.getProductType(entity) === ProductType.BESTA_INNER_LIGHT) {
                this.addOutlines([entity]);
            }
            else {
                this.addOutlinesToLightsOnFrame(entity);
            }
        }
    }
    onRemove(entity) {
        if (entity.hasComponent(ComponentIds.LIGHT_COMPONENT_ID)) {
            this.removeOutlinesFromAllLights();
        }
    }
    onUpdate() { }
    addOutlines(entities) {
        entities.forEach(entity => {
            entity.addComponent(new OutlinedComponent());
        });
    }
    removeOutlines(entities) {
        entities.forEach(entity => {
            entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        });
    }
    addOutlinesToLightsOnFrame(selectedEntity) {
        const parent = this.coreApi.entities.getParent(selectedEntity);
        if (parent) {
            const allLights = this.coreApi.entities.getDescendantsWithComponent(parent, ComponentIds.LIGHT_COMPONENT_ID);
            const isDirectChild = (entity) => this.coreApi.entities.getParent(entity) === parent;
            this.addOutlines(allLights.filter(isDirectChild));
        }
        else {
            this.addOutlines([selectedEntity]);
        }
    }
    removeOutlinesFromAllLights() {
        const allLights = this.coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);
        this.removeOutlines(allLights);
    }
}
//# sourceMappingURL=LightSelectionSystem.js.map